import { Manipulation, Zoom, Thumbs } from 'swiper';
window.Swiper.use([Manipulation, Zoom, Thumbs]);

export default function setGallery(Product) {
  // Cria swipers thumb e principal
  const thumbs = new Swiper(Product.thumbsSlider.element, {
    slidesPerView: 6,
    spaceBetween: 32,
    speed: 1000,
    watchSlidesProgress: true,
    watchOverflow: true,
    preloadImages: false,
    centerInsufficientSlides: true,
    lazy: {
      checkInView: true,
      loadOnTransitionStart: true,
      loadPrevNext: false,
    },
  });

  const main = new Swiper(Product.mainSlider.element, {
    slidesPerView: 1,
    speed: 1000,
    watchOverflow: true,
    watchSlidesProgress: true,
    thumbs: {
      swiper: thumbs,
    },
    pagination: {
      el: '[data-product-images] .swiper-pagination',
      type: 'bullets',
      clickable: true,
    },
    preloadImages: false,
    lazy: {
      checkInView: true,
      loadOnTransitionStart: true,
    },
    zoom: {
      maxRatio: 1.5,
      zoomedSlideClass: '-zoomed',
    },
  });

  Product.thumbsSlider.swiper = thumbs;
  Product.mainSlider.swiper = main;
}
